<template>
    <div>
        <ModuleNavDrawer
            v-model="drawer"
            :title="$t('nav.operationResources.title')"
            brand-icon="mdi-office-building-marker"
            :items="modules"
            :active-value="activeModule"
            @select="changeModule"
        />
        <CRUDLinhas v-if="activeModule === 'linhas'" />
        <CRUDRotas v-else-if="activeModule === 'rotas'" />
        <CRUDCercas v-else-if="activeModule === 'cercas'" />
        <CRUDUnidades v-else-if="activeModule === 'unidades'" />
        <CRUDAreas v-else-if="activeModule === 'areas'" />
    </div>
</template>

<script>
import ModuleNavDrawer from './ModuleNavDrawer.vue';
import CRUDLinhas from './CRUDLinhas.vue';
import CRUDRotas from './CRUDRotas.vue';
import CRUDCercas from './CRUDCercas.vue';
import CRUDUnidades from './CRUDUnidades.vue';
import CRUDAreas from './CRUDAreas.vue';
import { canAccessScreen, normalizePermissoesTelas } from '@/utils/postLoginNavigation';

export const MODULE_DEFS = [
    { value: 'linhas', screen: 'Linhas', icon: 'mdi-routes', labelKey: 'nav.registration.lines' },
    { value: 'rotas', screen: 'Rotas', icon: 'mdi-map-marker-path', labelKey: 'nav.registration.routes' },
    { value: 'cercas', screen: 'Cercas', icon: 'mdi-vector-polygon', labelKey: 'nav.registration.geofences' },
    { value: 'unidades', screen: 'Unidades', icon: 'mdi-domain', labelKey: 'nav.registration.units' },
    { value: 'areas', screen: 'Areas', icon: 'mdi-vector-square', labelKey: 'nav.registration.areas' },
];

export default {
    name: 'RecursosOperacao',
    provide() {
        return {
            recursosOperacaoModuleDefs: MODULE_DEFS,
        };
    },
    components: {
        ModuleNavDrawer,
        CRUDLinhas,
        CRUDRotas,
        CRUDCercas,
        CRUDUnidades,
        CRUDAreas,
    },
    data: () => ({
        drawer: false,
        activeModule: 'linhas',
        user: null,
        permissoesTelas: [],
    }),
    computed: {
        modules() {
            return MODULE_DEFS
                .filter((mod) => canAccessScreen(this.user, this.permissoesTelas, mod.screen))
                .map((mod) => ({
                    text: this.$t(mod.labelKey),
                    value: mod.value,
                    icon: mod.icon,
                }));
        },
    },
    watch: {
        '$route.query.modulo'(val) {
            this.syncModuleFromQuery(val);
        },
        modules: {
            immediate: true,
            handler() {
                this.ensureActiveModulePermitted();
            },
        },
    },
    created() {
        try {
            this.user = JSON.parse(sessionStorage.getItem('user'));
        } catch (e) {
            this.user = null;
        }
        try {
            this.permissoesTelas = normalizePermissoesTelas(
                JSON.parse(sessionStorage.getItem('permissoes'))
            );
        } catch (e) {
            this.permissoesTelas = [];
        }
        this.syncModuleFromQuery(this.$route && this.$route.query ? this.$route.query.modulo : null);
        const current = (this.$route && this.$route.query) || {};
        if (current.modulo !== this.activeModule) {
            this.$router.replace({
                path: '/recursosoperacao',
                query: { ...current, modulo: this.activeModule },
            }).catch(() => {});
        }
    },
    methods: {
        syncModuleFromQuery(modulo) {
            const allowed = this.modules.map((m) => m.value);
            if (modulo && allowed.includes(modulo)) {
                this.activeModule = modulo;
                return;
            }
            this.ensureActiveModulePermitted();
        },
        ensureActiveModulePermitted() {
            const allowed = this.modules.map((m) => m.value);
            if (allowed.includes(this.activeModule)) return;
            this.activeModule = allowed.includes('linhas')
                ? 'linhas'
                : (allowed[0] || 'linhas');
        },
        changeModule(module) {
            if (!module || module.value == null) return;
            this.activeModule = module.value;
            const current = (this.$route && this.$route.query) || {};
            if (current.modulo === module.value) return;
            const query = { ...current, modulo: module.value };
            this.$router.replace({ path: '/recursosoperacao', query }).catch(() => {});
        },
    },
};
</script>
